import {reactive} from 'vue'
// Shared default positions prevent simultaneous notice types covering one another.
export const popupStack=reactive<{id:number;height:number}[]>([])
